import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { CatalogFormInputProps } from '../types';
import { validateQuestionDebounced } from '../utils/checks';

// Mirrors DATA_ASSET_OWNER_PATTERN in the accounts API, which accepts no-entry.
export const DATA_ASSET_OWNER_PATTERN = /^(no-entry|[^\s@]+@[^\s@]+\.[^\s@]+)$/;

export function DataAssetOwner(props: CatalogFormInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="pfg_data_asset_owner"
          id="pfg_data_asset_owner"
          label="Data Asset Owner"
          variant="outlined"
          className={classes.root}
          validation={{
            required: 'Data Asset Owner is required',
            pattern: {
              value: DATA_ASSET_OWNER_PATTERN,
              message:
                "Data Asset Owner must be a valid email (e.g. name@principal.com) or 'no-entry'",
            },
            validate: async value => {
              return await validateQuestionDebounced(
                'pfg_data_asset_owner',
                value,
                props.apiValidation,
                workloadClient,
              );
            },
          }}
          fullWidth
          required
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              The owner of this account's data assets for data governance.
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
